import { CalculationQuestionI } from "./CalculationQuestion";
import { QuestionType } from "./common";
import { MultiModelQuestionI } from "./MultiModelQuestion";
import { MultiReasonQuestionI } from "./MultiReasonQuestion";
import { AnyQuestionI, TextQuestionI } from "./Question";
import { SimpleQuestionI } from "./SimpleQuestion";

export function isSimpleQuestion(
  value: AnyQuestionI
): value is SimpleQuestionI {
  return !value.type || value.type === QuestionType.SIMPLE;
}

export function isMultiReasonQuestion(
  value: AnyQuestionI
): value is MultiReasonQuestionI {
  return value.type === QuestionType.MULTI_REASON;
}

export function isMultiModelQuestion(
  value: AnyQuestionI
): value is MultiModelQuestionI {
  return value.type === QuestionType.MULTI_MODEL;
}

export function isTextQuestion(value: AnyQuestionI): value is TextQuestionI {
  return (
    isSimpleQuestion(value) ||
    isMultiReasonQuestion(value) ||
    isMultiModelQuestion(value)
  );
}

export function isCalculationQuestion(
  value: AnyQuestionI
): value is CalculationQuestionI {
  return value.type === QuestionType.CALCULATION;
}
